import { createTheme } from '@mui/material/styles';
import { remCalc } from '../../utils/remCalc';
import breakpoints from '../../utils/breakpoints';
const theme = createTheme({
	breakpoints: breakpoints,
});

const styles = {
	components: {
		MuiContainer: {
			styleOverrides: {
				root: {
					'&.TwoColumn-root': {
						marginBottom: remCalc(50),

						'&.padding-normal': {
							paddingTop: remCalc(30),
							paddingBottom: remCalc(30),
							[theme.breakpoints.up('sm')]: {
								paddingTop: remCalc(100),
								paddingBottom: remCalc(100),
							},
						},

						'&.margin-flush': {
							marginBottom: 0,
						},
					},
				},
			},
		},
	},
}

export default styles;